import Input from './input';
import TextArea from './textArea';
import Phone from './phone';
import PhoneWithMask from './phoneWithMask';

export { Input, TextArea, Phone, PhoneWithMask };
